import { IAppSession } from '@vfit/consumer/data-access';
import { getFromLocalStorageByKey, AppMobile } from '@vfit/shared/data-access';

const goDetail = (slug?: string, queryParamGoDetail?: string[]) => {
  if (!slug) return;
  const isApp = AppMobile.checkIsApp();
  const appSession: IAppSession = getFromLocalStorageByKey('appSession');
  const [basePath = '', existingQuery = ''] = window?.location?.href?.split('?') || [];
  const queryParams = queryParamGoDetail?.length ? queryParamGoDetail.join('&') : existingQuery;
  const href = `${basePath}/${slug}${queryParams ? `?${queryParams}` : ''}`;
  if (isApp && appSession) {
    AppMobile.openInBrowser(href);
    return;
  }
  window.location.href = href;
};

export { goDetail };
